/**
 * A place for common dateFilter things
 */
namespace appn.dateFilter {
    export function init(dfilter: string, customFilterCallBack?: Function) {
        // Auto select the initial default filter
        const state = dfilter ? dfilter : getStateOrDefaultAsString();
        dfilter = state ? state : 'ThisMonth';
        setValueFromString(dfilter);
        addEvents(customFilterCallBack);
    }

    function addEvents(customFilterCallBack?: Function) {
        $('.appnDateFilter #customfilter').off().on('click', function(e) {
            e.preventDefault();
            $('#CustomRange').click();
            if (customFilterCallBack)
                customFilterCallBack();
        });

        $('.appnDateFilter .appnDateFilter-link').off().on('click', function(e) {
            e.preventDefault();

            const appnDateFilter = $('.appnDateFilter');
            appnDateFilter.find('li').removeClass('active');
            $(this).closest('li').addClass('active');
            appn.dataTable.uncheckAllRowsBox();
        });

        $('.appnDateFilter .container-fluid').off().on('click', function(e) {
            e.stopPropagation();
        });
    }

    /**
     * Will get the date filters value from local storage or direct from UI is not in LS.
     */
    export function getStateOrDefault(): IdtFilterValues {
        const appnDateFilter = $('.appnDateFilter');
        const dateFilterValue = appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilter), getValueAsString()).value;
        const dateFilterValues = getValue(dateFilterValue);
        return dateFilterValues;
    }

    export function getStateOrDefaultAsString(): string {
        const appnDateFilter = $('.appnDateFilter');
        return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilter), getValueAsString()).value;
    }

    export function getValueAsString(): string {
        const activeValue = getValue();
        if (!activeValue)
            return appn.emptyString;

        return activeValue.type + '|' + activeValue.fromDate + '|' + activeValue.toDate;
    }

    export function getValue(valueString?: string): IdtFilterValues {
        // Set the defaults in case of population problems
        const url = window.location.href;
        const filterValues: IdtFilterValues = {
            type: url.toLowerCase().contains('TaskTemplates'.toLowerCase()) ? 'All' : 'ThisMonth',
            fromDate: appn.emptyString,
            toDate: appn.emptyString
        };

        if (valueString) {
            const bits = valueString.split('|');
            filterValues.type = bits[0];
            filterValues.fromDate = bits[1];
            filterValues.toDate = bits[2];
            return filterValues;
        }

        const appnDateFilter = $('.appnDateFilter');
        const type = appnDateFilter.find('li.active .appnDateFilter-link').prop('id');
        if (type)
            filterValues.type = type;

        filterValues.fromDate = appnDateFilter.find('#FromDate').val() as string;
        filterValues.toDate = appnDateFilter.find('#ToDate').val() as string;

        return filterValues;
    }

    function isAtLeastOneActive(): boolean {
        return $('.appnDateFilter').find('li').hasClass('active');
    }

    export function setValueFromString(value: string) {
        if (!value)
            return;

        if (isAtLeastOneActive() && getValueAsString() === value)
            return; // No need to set if already the same

        // Set the active class
        const bits = value.split('|');
        const appnDateFilter = $('.appnDateFilter');
        appnDateFilter.find('li').removeClass('active');
        appnDateFilter.find('#' + bits[0]).closest('li').addClass('active');

        if (bits[1])
            appnDateFilter.find('#FromDate').val(bits[1]);

        if (bits[2])
            appnDateFilter.find('#ToDate').val(bits[2]);

        appn.dataTable.uncheckAllRowsBox();
    }

    export function reset() {
        setValueFromString('ThisMonth');
    }
}
